import React, { useEffect, useState } from 'react';
import './CookieConsent.css';

/**
 * CookieConsent Component für CCM19 Integration
 * 
 * Diese Komponente zeigt einen Fallback-Banner NUR auf localhost.
 * Auf Production wird ausschließlich der echte CCM19-Banner verwendet.
 */
const CookieConsent = () => {
  const [showFallbackBanner, setShowFallbackBanner] = useState(false);
  const [isLocalhost, setIsLocalhost] = useState(false);

  useEffect(() => {
    // Check if running on localhost
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
    setIsLocalhost(isLocal);

    // WICHTIG: Auf Production nichts tun - CCM19 übernimmt alles
    if (!isLocal) {
      return;
    }

    // Check if consent was already given (from localStorage)
    const existingConsent = localStorage.getItem('cookieConsent');
    if (existingConsent) {
      setShowFallbackBanner(false);
      return;
    }

    // Wait for CCM19 to load (only on localhost)
    const checkCCM = () => {
      if (window.CCM && window.CCM.acceptedEmbeddings) {
        setShowFallbackBanner(false);
      } else {
        // On localhost, show fallback banner if CCM19 doesn't load
        if (!window.CCM && !existingConsent) {
          setShowFallbackBanner(true);
        }
      }
    };

    // Check immediately and after delay
    checkCCM();
    const timer = setTimeout(checkCCM, 2000);

    // Listen for consent changes
    const handleConsentChange = () => {
      if (window.CCM && window.CCM.acceptedEmbeddings) {
        setShowFallbackBanner(false);
      }
    };

    window.addEventListener('ccm19WidgetClosed', handleConsentChange);
    window.addEventListener('ccm19ConfigLoaded', handleConsentChange);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('ccm19WidgetClosed', handleConsentChange);
      window.removeEventListener('ccm19ConfigLoaded', handleConsentChange);
    };
  }, [isLocalhost]);

  // Fallback functions for localhost testing
  const handleAcceptAll = () => {
    setShowFallbackBanner(false);
    localStorage.setItem('cookieConsent', 'all');
    console.log('✅ Localhost: Alle Cookies akzeptiert');
  };

  const handleAcceptNecessary = () => {
    setShowFallbackBanner(false);
    localStorage.setItem('cookieConsent', 'necessary');
    console.log('✅ Localhost: Nur notwendige Cookies akzeptiert');
  };

  // WICHTIG: Auf Production wird nichts gerendert
  if (!isLocalhost) {
    return null;
  }

  // Auf Localhost nur Banner, KEIN permanenter Button
  return (
    <>
      {showFallbackBanner && (
        <div className="fallback-cookie-banner">
          <div className="fallback-banner-content">
            <div className="fallback-banner-header">
              <h3>🍪 Cookie-Einstellungen (Localhost-Modus)</h3>
              <span className="localhost-badge">DEV MODE</span>
            </div>
            <p>
              <strong>Hinweis:</strong> CCM19 funktioniert nur auf echten Domains, nicht auf localhost. 
              Dies ist ein Fallback-Banner für die Entwicklung.
            </p>
            <p>
              Auf der produktiven Website wird hier der echte CCM19-Banner erscheinen.
            </p>
            <div className="fallback-banner-buttons">
              <button 
                className="fallback-btn primary"
                onClick={handleAcceptAll}
              >
                Alle akzeptieren (Test)
              </button>
              <button 
                className="fallback-btn secondary"
                onClick={handleAcceptNecessary}
              >
                Nur notwendige (Test)
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;
